// removed by extract-text-webpack-plugin
module.exports = {"Button":"Button__-loca-__31QXU","Submit":"Button__-loca-__1eoyR","Cancel":"Button__-loca-__1OHKO"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Buttons/Button/Button.css
// module id = 123
// module chunks = 0